<div class="app-criterion-evaluation">
  <p class="mt-2">
    {{
      criterion | propertyLocalized : ["descriptionAr", "descriptionEn"] | async
    }}
  </p>

  <form [formGroup]="formGroup">
    <div class="row">
      <div
        class="mb-3 col-md-6"
        *ngFor="let subCriterion of criterion.subCriterions"
      >
        <label class="font-weight-bold field-required">
          {{
            subCriterion
              | propertyLocalized : ["subCriterionNameAr", "subCriterionNameEn"]
              | async
          }}
        </label>
        <br />
        <mat-radio-group
          class="d-flex flex-wrap"
          [formControlName]="subCriterion.subCriterionKey"
        >
          <span
            class="group border"
            *ngFor="let group of subCriterion.evaluation"
            [matTooltip]="
              group
                | propertyLocalized : ['evaluationDescAr', 'evaluationDescEn']
                | async
            "
          >
            <mat-radio-button
              *ngFor="let item of group.items"
              [value]="item.value"
              >{{ item.label }}</mat-radio-button
            >
          </span>
        </mat-radio-group>
      </div>
    </div>

    <!-- <label class="font-weight-bold field-required">
			{{ 'forms.common.totalEvaluation' | translate }}
		</label>
		<mat-form-field appearance="outline">
			<input type="number" matInput formControlName="totalEvaluation" />
		</mat-form-field> -->

    <label class="font-weight-bold">
      {{ "forms.common.notes" | translate }}
    </label>
    <mat-form-field appearance="outline">
      <textarea
        matInput
        cdkAutosizeMinRows="3"
        cdkAutosizeMaxRows="3"
        formControlName="notes"
      ></textarea>
    </mat-form-field>
  </form>
</div>
